import React from "react";
import { useTranslation } from "react-i18next";
import { NS } from "../U3129";
import { useU2000LogicalUnitContext } from "../../u2000Core/context/logicalUnit/U2000LogicalUnitContext";

const U3129EmployeeNotConfigured: React.FC = () => {
  const { t } = useTranslation();
  const { setLogicalUnitBreadcrumb } = useU2000LogicalUnitContext();

  React.useEffect(() => {
    setLogicalUnitBreadcrumb([{ label: t("title", { ns: NS }) }]);
    return () => setLogicalUnitBreadcrumb([]);
  }, [t, setLogicalUnitBreadcrumb]);

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center px-4 py-8">
      <div className="w-full max-w-lg rounded-lg border border-amber-200 bg-amber-50/80 p-6 text-center shadow-xs">
        <h2 className="text-lg font-semibold text-amber-900">
          {t("msgEmployeeNotConfiguredTitle", { ns: NS })}
        </h2>
        <p className="mt-3 text-sm text-amber-800">
          {t("msgEmployeeNotConfiguredBody", { ns: NS })}
        </p>
      </div>
    </div>
  );
};

export default U3129EmployeeNotConfigured;
